import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_post_notes = _resolveComponent("post-notes")!
  const _component_post = _resolveComponent("post")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Post Notes",
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_post_notes, {
        "post-id": _ctx.post.id,
        class: "q-mb-md"
      }, null, 8, ["post-id"]),
      _createVNode(_component_post, { post: _ctx.post }, null, 8, ["post"])
    ]),
    _: 1
  }, 512))
}